import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import BaseService from 'services/BaseService'
import { popNotification } from 'utils/popNotification'
import { notificationConfig } from './constants'
import { LIMIT } from 'constants/app.constant'
import { formatDateSend } from '../../functions/formatDateSend'

const { creation, edit, deletion } = notificationConfig

// Redux Toolkit slice
const opportunitesSlice = createSlice({
    name: 'opportunites',
    initialState: {
        data: [],
        isLoading: false,
        error: null,
        created: null,
        isDeleted: null,
        currentPage: 1,
    },
    reducers: {
        resetDetailsOpportunite: (state) => {

            if (state.detailsOpportunite == null) {
                state.detailsOpportunite = ''
            }else{
                state.detailsOpportunite = null
            }
        },
    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchDetailsOpportunites.pending, (state) => {
            state.isLoading = true
            state.error = null
        })
        .addCase(fetchDetailsOpportunites.fulfilled, (state, action) => {
            const currentPage = action?.meta?.arg?.page || state.currentPage;

            state.currentPage = currentPage
            state.isLoading = false
            state.detailsOpportunite = action.payload
        })
        .addCase(fetchDetailsOpportunites.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message
        })
            .addCase(fetchOpportunites.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchOpportunites.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || state.currentPage;

                state.currentPage = currentPage
                state.isLoading = false
                state.data = action.payload
            })
            .addCase(fetchOpportunites.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })
            .addCase(createOpportunite.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(createOpportunite.fulfilled, (state, action) => {
                state.isLoading = false
                state.created = true
            })
            .addCase(createOpportunite.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.created = false
            })
            .addCase(deleteOpportunite.pending, (state) => {
                state.isLoading = true
                state.isDeleted = null
            })
            .addCase(deleteOpportunite.fulfilled, (state) => {
                state.isLoading = false
                state.isDeleted = true
            })
            .addCase(deleteOpportunite.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.isDeleted = false
            })
    },
})

// Async thunk action to fetch data from the API
export const fetchOpportunites = createAsyncThunk(
    'opportunites/fetch',
    async (payload) => {
        const page = payload?.page || 1
        const limit = payload?.limit || LIMIT
        const search = payload?.search || ''
        const statut_f = payload?.statut_f || ''
        let date_d_f = payload?.date?.[0] || ''
        let date_f_f = payload?.date?.[1] || ''
        if (dayjs(date_d_f).isValid() && dayjs(date_f_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
        } else if (dayjs(date_d_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = date_d_f;
        } else if (dayjs(date_f_f).isValid()) {
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
            date_d_f = date_f_f;
        }
        try {
            const response = await BaseService.get(
                `/XML/crm.pip.load/opportunite?page=${page}&limit=${limit}&text=${search}&statut_f=${statut_f}&date_d_f=${date_d_f}&date_f_f=${date_f_f}`
            )

            return response.data
        } catch (error) {
            throw new Error('Failed to fetch opportunites')
        }
    }
)
// Async thunk action to fetch details from the API
export const fetchDetailsOpportunites = createAsyncThunk(
    'Opportunites/fetchDetails',
    async (id) => {
        const data = {'id_opo':id.id}
        try {
            const Opportunite = await BaseService.post(
                `/XML/crm.pip.load/get_one_opportunite`,data
            )
            

            return Opportunite.data
        } catch (error) {
            throw new Error('Failed to fetch Opportunites')
        }
    }
)
export const createOpportunite = createAsyncThunk(
    'opportunites/post',
    async (payload) => {
        const { data, formik, navigate, setClientAdded } = payload
        const { resetForm, setSubmitting } = formik
      
        try {
            const response = await BaseService.post('/XML/crm.pip.send/new', data)
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                setClientAdded(true)
            }
        } catch (err) {
            console.log({ err })
            
            setSubmitting(false)
            
            popNotification(creation?.error)
        }
    }
)


export const createEvent = createAsyncThunk(
    'opportunites/post',
    async (payload) => {
        const { data, formik, navigate, setClientAdded } = payload
        const { resetForm, setSubmitting } = formik
      
        try {
            const response = await BaseService.post('/XML/crm.pip.send/add_event', data)
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                setClientAdded(true)
            }
        } catch (err) {
            console.log({ err })
            
            setSubmitting(false)
            
            popNotification(creation?.error)
        }
    }
)

export const editOpportunite = createAsyncThunk('opportunites/edit', 
async (payload) => {
    const { data, formik, navigate, setClientAdded } = payload
    const { resetForm, setSubmitting } = formik
  
    try {
        const response = await BaseService.post('/XML/crm.pip.send/m_opo', data)
        if (response.status === 200) {
            resetForm()
            setSubmitting(false)
            popNotification(creation?.success)
            setClientAdded(true)
        }
    } catch (err) {
        console.log({ err })
        
        popNotification(creation?.error)
    }
})

export const deleteOpportunite = createAsyncThunk(
    'opportunite/delete',
    async (payload) => {
        const { id, closeDialog } = payload
        if (!id) return
        try {
            const response = await BaseService.delete(`/opportunites/${id}`)
            if (response.status === 200 || response.status === 201) {
                popNotification(deletion?.success)
                closeDialog()
                return true
            }
        } catch (err) {
            console.log({ err })
            popNotification(deletion?.error)
            return
        }
    }
)

export const selectData = (state) => state.opportunites.data
export const selectIsLoading = (state) => state.opportunites.isLoading
export const selectError = (state) => state.opportunites.error
export const selectIsDeleted = (state) => state.opportunites.isDeleted
export const selectCurrentPage = (state) => state.opportunites.currentPage
export const resetDetailsOpportunite = opportunitesSlice.actions.resetDetailsOpportunite
export default opportunitesSlice.reducer
